import { makeObservable } from 'mobx'

import { Tenant } from '@authy/lib-common/entities'
import { client } from '@authy/lib-client/trpc'
import { AdminAppState, NavigationItem } from '@authy/lib-admin/appState'

import { router } from '@/router'

import { createMainNavigation } from './createMainNavigation'

export type UserTenantType = Pick<Tenant, '_id' | 'name' | 'avatar' | 'shortId'>

export class AppState extends AdminAppState {
    userTenants: UserTenantType[] = []

    constructor() {
        super('root')
        makeObservable(this, {})
    }

    async init() {
        await super.init({ forceUser: true, router })

        await Promise.all([this.loadTenants()])
    }

    get mainNavigation(): NavigationItem[] {
        return createMainNavigation({ language: this.language })
    }

    async loadTenants() {
        this.userTenants = await client.currentUser.getTenants.query()
    }
}
